module.exports = __webpack_public_path__ + "static/background-05b858c1a8f64429df6d3748729304f1.webp";